import axios from 'axios';
import * as HttpStatus from 'http-status-codes';
import { EMPTY_LIST } from '../../../../utils/listFetchState';
import { teamListSelector } from './TeamSelectors';

const API_BASE = process.env.REACT_APP_API_BASE;

export const types = {
  REQUEST_TEAMS: 'team/REQUEST_TEAMS',
  RECEIVE_TEAMS: 'team/RECEIVE_TEAMS',
};

const requestTeams = () => ({ type: types.REQUEST_TEAMS });
const receiveTeams = (data, fetchStatus = 'ok') => ({
  type: types.RECEIVE_TEAMS,
  teamList: data,
  fetchStatus,
});

export const updateTeam = (planId, teamId, data) => () => {
  const url = `${API_BASE}plans/${planId}/teams/${teamId}`;
  return axios.patch(url, data);
};

export const deleteTeam = (planId, teamId) => () => {
  const url = `${API_BASE}plans/${planId}/teams/${teamId}`;
  return axios.delete(url);
};

export const fetchTeam = (planId) => async (dispatch, getState) => {
  const previousTeams = teamListSelector(getState());
  dispatch(requestTeams());
  const url = `${API_BASE}plans/${planId}/teams`;
  try {
    const res = await axios.get(url);
    dispatch(receiveTeams(res.data, 'ok'));
    return res;
  } catch (err) {
    const status = err?.response?.status;

    if (status === HttpStatus.NOT_FOUND || status === HttpStatus.BAD_REQUEST) {
      dispatch(receiveTeams(EMPTY_LIST, 'not_found'));
    } else if (status === HttpStatus.PAYMENT_REQUIRED) {
      dispatch(receiveTeams(previousTeams ?? EMPTY_LIST, 'payment_required'));
    } else {
      dispatch(receiveTeams(previousTeams ?? EMPTY_LIST, 'error'));
    }

    return Promise.reject(err);
  }
};

export const createTeamContact = (planId, teamId, data) => async (dispatch, getState) => {
  const previousTeams = teamListSelector(getState());
  dispatch(requestTeams());
  const url = `${API_BASE}plans/${planId}/teams/${teamId}/contacts`;
  try {
    const res = await axios.post(url, data);
    await dispatch(fetchTeam(planId));
    return res;
  } catch (err) {
    dispatch(receiveTeams(previousTeams));
    return Promise.reject(err);
  }
};

export const updateTeamContact = (planId, teamId, contactId, data) => async (dispatch, getState) => {
  const previousTeams = teamListSelector(getState());
  dispatch(requestTeams());
  const url = `${API_BASE}plans/${planId}/teams/${teamId}/contacts/${contactId}`;
  try {
    const res = await axios.patch(url, data);
    await dispatch(fetchTeam(planId));
    return res;
  } catch (err) {
    dispatch(receiveTeams(previousTeams));
    return Promise.reject(err);
  }
};

export const deleteTeamContact = (planId, teamId, contactId) => async (dispatch, getState) => {
  const previousTeams = teamListSelector(getState());
  dispatch(requestTeams());
  const url = `${API_BASE}plans/${planId}/teams/${teamId}/contacts/${contactId}`;
  try {
    const res = await axios.delete(url);
    await dispatch(fetchTeam(planId));
    return res;
  } catch (err) {
    dispatch(receiveTeams(previousTeams));
    return Promise.reject(err);
  }
};
